import { Map, fromJS } from "immutable";

export const parseFilters = (location): Map<any, any> => {
    let filters = Map();
    try {
        filters = fromJS(JSON.parse(location.query.filters || "{}"));
    } catch (e) {
        // no-op
    }

    return filters;
};
